import { Card } from '@material-ui/core'
import { TCFDIVersion } from 'models/invoices.models'
import { selectSelectedInvoice } from 'lib/helpers/selectors'
import ScrollSpy from 'components/Invoices/ScrollSpy/ScrollSpy'
import PaymentComplementForm from 'components/Invoices/PaymentComplements/PaymentComplementForm/PaymentComplementForm'
import PaymentComplementCFDIInfo from 'components/Invoices/PaymentComplements/PaymentComplementCFDIInfo/PaymentComplementCFDIInfo'
import { useAppSelector } from 'store/hooks'
import useAddPaymentComplementContainer from './useAddPaymentComplementContainer'
import './styles.scss'

export interface IAddPaymentComplementContainerProps {
  invoiceId: number
  version: TCFDIVersion
  cleanup: () => void
}

const AddPaymentComplementContainer = ({
  invoiceId,
  version,
  cleanup,
}: IAddPaymentComplementContainerProps) => {
  const invoice = useAppSelector(selectSelectedInvoice)

  const addPaymentComplementContainerState = useAddPaymentComplementContainer({
    invoice,
    invoiceId,
    version,
    cleanup,
  })

  return (
    <>
      <PaymentComplementCFDIInfo invoice={invoice} version={version} />
      <Card elevation={1} className="container-add-payment-complement">
        <div className="scrollspy-container">
          <ScrollSpy
            items={[
              { id: 'section-1', label: '1', tooltip: 'Recepción de pagos' },
              {
                id: 'section-2',
                label: '2',
                tooltip: 'Documentos relacionados',
              },
            ]}
          />
        </div>
        <div className="form-container">
          <PaymentComplementForm
            {...addPaymentComplementContainerState}
            version={version}
          />
        </div>
      </Card>
    </>
  )
}

export default AddPaymentComplementContainer
